import config from '@/utils/config';
import { createStore } from 'vuex';
import Cookies from 'js-cookie';
import {isDev, isLocal} from './helpers';
import {EventBus} from '@/utils/eventBus';
import qs from 'qs';
import HTTP from '@/utils/axios';

const cognitoUrl = (isDev() || isLocal()) ?
    'https://zeto-deploymentdev.auth.eu-central-1.amazoncognito.com/':
    'https://zeto-deployment.auth.eu-central-1.amazoncognito.com/';

const clientId = (isDev() || isLocal()) ? '58sdv2iptbug5hkl6ol10d2l6n' : 'm94t4eqg55d92n0opaop7uc1f';

export default createStore({
    state: {
        messages: [],
        releases: [],
        selectedRelease: null,
        environments: [],
        roles: [],
        token: Cookies.get('deployment-token') || null
    },
    getters: {
        releases: state => state.releases,
        token: state => state.token,
        selectedRelease: state => state.selectedRelease,
        environments: state => state.environments,
        roles:  state => state.roles,
        messages:  state => state.messages
    },

    mutations: {
        SAVE_TOKEN (state, token) {
            state.token=token;
            //expires in 1 hour
            Cookies.set('deployment-token', token, { expires: 1/24});
        },

        RELEASE_TOKEN (state, token) {
            state.token=null;
            Cookies.remove('deployment-token');
        },

        UPDATE_RELEASE (state, release) {
            state.selectedRelease=release;
        },

        CLEAR_RELEASE (state) {
            state.selectedRelease=null;
        },

        UPDATE_RELEASES (state, { releases }) {
            state.releases=releases;
        },

        UPDATE_RELEASES_FAILURE (state) {
            state.releases=[];
        },

        UPDATE_ENVIRONMENTS (state, { environments }) {
            state.environments=environments;
        },

        UPDATE_ENVIRONMENT(state, environment) {
            const enviroments = state.environments;
            const idx = enviroments.findIndex(env => env.Environment == environment.Environment);
            environments[idx] = enviroment;
            state.environments=environments;
        },

        ADD_ENVIRONMENT (state, environment) {
            const environments = [...state.environments, environment];
            state.environments=environments;
        },

        CLEAR_ENVIRONMENTS (state) {
            state.environments=[];
        },

        UPDATE_ROLES (state, { roles }) {
            state.roles=roles;
        },

        CLEAR_ROLES (state) {
            state.roles=[]
        },

        PUSH_MESSAGE (state, message) {
            const messages = [...state.messages, message];
            state.messages=messages;
        },

        POP_MESSAGE (state) {
            const messages = state.messages;
            messages.shift();
            state.messages=messages;
        }
    },

    actions: {

        async addMessage ({ commit }, message) {
            commit('PUSH_MESSAGE', message);
            setTimeout(() => {
                commit('POP_MESSAGE');
            }, 5000);
        },

        /**
         *
         * Selects the release 
         */
        async selectRelease({ commit }, release) {
            commit('UPDATE_RELEASE', release);
        },

        /**
         *
         * Deselect the release 
         */
        async closeRelease({ commit }) {
            commit('CLEAR_RELEASE');
        },

        /**
         * Saves the token
         */
        async getTokens ({commit}) {
            try {
                const cookie = Cookies.get('deployment-token');
                if (cookie && cookie != 'null') {
                    return new Promise((resolve, reject) => {
                        resolve();
                    });
                } else {
                    const url = new URL(window.location.href);
                    let params = {...config.initData, ...{code: url.searchParams.get('code')}};
                    const {data} = await HTTP.post(`${cognitoUrl}oauth2/token`, qs.stringify(params));
                    return new Promise((resolve, reject) => {
                        commit('SAVE_TOKEN', data.id_token);
                        resolve();
                    });
                }
            } catch (e) {
                commit('RELEASE_TOKEN');
                return Promise.reject(new Error('Getting token failed'));
            }
        },

        /**
         * Fetch releases from aws
         */
        async fetchReleases({ commit }) {
            try {
                const { data } = await HTTP.get('/deployment/releases');
                return new Promise((resolve, reject) => {
                    commit('UPDATE_RELEASES', {releases: data.release});
                    resolve();
                });
            } catch (e) {
                commit('UPDATE_RELEASES_FAILURE');
                return Promise.reject(new Error('Fetching releases failed'));
            }
        },

        /**
         * Fetch environments from aws
         */
        async fetchEnvironments({ commit, getters }) {
            try {
                const release = getters.selectedRelease;
                const { data } = await HTTP.get('/deployment/environments/' + release.ReleaseDate, {
                    skipProgressbar: true
                });
                commit('UPDATE_ROLES', {roles: data.roles});
                commit('CLEAR_ENVIRONMENTS');
                data.environment.forEach(async (env) => {
                    commit('ADD_ENVIRONMENT', env);
                });
                return new Promise((resolve, reject) => {
                    EventBus.emit('fetchEnvironmentUpdate');
                    resolve();
                });
            } catch (e) {
                commit('CLEAR_ENVIRONMENTS');
                commit('CLEAR_ROLES');
                console.log(e);
                return Promise.reject(new Error('Fetching environments failed'));
            }
        },

        /**
         * Fetches the deployment data for the master-slave view
         */
        async fetchMainData ({ commit }, payload) {
            try {
                const { data } = await HTTP.get('/deployment/information');
                return new Promise((resolve, reject) => {
                    commit('UPDATE_RELEASES', {releases: data.release});
                    commit('UPDATE_ENVIRONMENTS', {environments: data.environment});
                    commit('UPDATE_ROLES', {roles: data.roles});
                    resolve();
                });
            } catch (e) {
                commit('UPDATE_RELEASES_FAILURE');
                commit('CLEAR_ENVIRONMENTS');
                commit('CLEAR_ROLES');
                return Promise.reject(new Error('Fetching main data failed'));
            }
        },

        logout({ commit }) {
            try {
                commit('RELEASE_TOKEN');
                const redirectUrl = `${cognitoUrl}logout?client_id=${clientId}&logout_uri=${window.location.origin}`;
                window.location.replace(redirectUrl);
            } catch (e) {
                return Promise.reject(new Error('Unable to log the user out!'));
            }
        }
    }
});

